import { cn } from "@pulsex/utils";
import { MenuItem as MenuItemType } from "@pulsex/types";
import { faAngleRight, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import * as React from "react";
import { usePathname } from "next/navigation";

export interface IMenuItemProps {
    item: MenuItemType;
}

export default function MenuItem({ item }: IMenuItemProps) {
    const pathname = usePathname();
    const getIsActive = (item: MenuItemType) => {
        if(item.url === pathname) return true;
        if(item.subMenus) {
            return item.subMenus.some((subItem) => getIsActive(subItem));
        }
        return false;
    }
    return (
        <li
            className={cn(
                "relative group h-full flex items-center hover:cursor-pointer",
                "lg:h-auto lg:flex-col lg:items-start lg:gap-3 lg:mb-5"
            )}
        >
            <Link
                href={item?.url ?? "#"}
                className={cn("relative flex items-center", "lg:font-semibold")}
            >
                <span>{item?.title}</span>
                {item?.subMenus && item?.subMenus.length > 0 && (
                    <FontAwesomeIcon
                        icon={faCaretDown}
                        className="ml-1 group-hover:text-primary lg:hidden"
                    />
                )}
                {item.url && (
                    <FontAwesomeIcon
                        icon={faAngleRight}
                        className="ml-2 group-hover:text-primary w-2 !hidden lg:!block"
                    />
                )}
            </Link>
            <div className="absolute left-0 -bottom-[0px] w-full h-1 bg-primary scale-x-0 transition-transform duration-300 group-hover:scale-x-100 lg:hidden"></div>
            {item?.subMenus && item?.subMenus.length > 0 && (
                <div
                    className={cn(
                        "absolute left-0 z-50 top-full w-[170px] max-h-0 opacity-0 bg-white shadow-lg transition-[max-height] duration-700 ease-in-out overflow-hidden group-hover:transition-opacity group-hover:duration-700 group-hover:opacity-100 group-hover:max-h-[1000px] p-0 hover:cursor-pointer dark:bg-bgblue",
                        "lg:static lg:grid lg:h-auto lg:max-h-max lg:opacity-100 grid-cols-2 gap-4 lg:bg-transparent lg:shadow-none lg:w-full"
                    )}
                >
                    {item?.subMenus.map((subitem, subIndex) => (
                        <div
                            key={subIndex}
                            className="hover:bg-gray-300/40 dark:hover:bg-gray-300/15 transition-all duration-300 whitespace-nowrap"
                        >
                            <Link
                                href={subitem?.url ?? "#"}
                                className={cn(
                                    "text-[13px]  block w-full h-full p-3",
                                    "lg:p-0"
                                )}
                            >
                                {subitem?.title}
                            </Link>
                        </div>
                    ))}
                </div>
            )}


            {/* active indicator */}
            {
                getIsActive(item) && <div className="absolute w-full h-1 bg-blue bottom-0 left-0 right-0 dark:bg-white"></div>
            }
        </li>
    );
}
